<div
  class="object-view-and-edit"
  [ngClass]="{'template-selector': this.sectionsContainer.isTemplate}"
>
  <div>
    @if (!isEditing) {
      <app-object-view
        [objectId]="sectionsContainer.rootObject.artifact_id"
        [sectionsContainer]="sectionsContainer"
        [templateGroupId]="templateGroupId || sectionsContainer.templateGroupId"
        [hideSectionTitle]="sectionsContainer.hideSectionTitle"
      ></app-object-view>
    }
    @else {
      <app-object-edit
        [sectionsContainer]="sectionsContainer"
        (closeEdit)="onCloseEdit()"
      ></app-object-edit>
    }

    @if (sectionsContainer.debug) {
      <div style="float:left;">
        <pre>
          {{sectionsContainer.rootObject | json}}
        </pre>
      </div>
    }
  </div>
</div>
